import AuthGuard from 'app/auth/AuthGuard'
import NotFound from 'app/views/sessions/NotFound'
import chartsRoute from 'app/views/charts/ChartsRoute'
import reportsRoute from 'app/views/reports/ReportsRoute'
import materialRoutes from 'app/views/material-kit/MaterialRoutes'
import usersRoute from 'app/views/users/UsersRoute'
import dashboardRoutes from 'app/views/dashboard/DashboardRoutes'
import sessionRoutes from 'app/views/sessions/SessionRoutes'
import MatxLayout from '../components/MatxLayout/MatxLayout'
import { Navigate } from 'react-router-dom'
import KenoRoute from 'app/views/Keno/KenoRoute'

export const AllPages = () => {
    const all_routes = [
        {
            element: (
                <AuthGuard>
                    <MatxLayout />
                </AuthGuard>
            ),
            children: [...dashboardRoutes, ...chartsRoute, ...reportsRoute, ...materialRoutes, ...usersRoute, ...KenoRoute],
            // children: [...dashboardRoutes, ...chartsRoute, ...reportsRoute, ...materialRoutes, ...usersRoute, ...KenoRoute],
        },
        ...sessionRoutes,
        {
            path: '/',
            element: <Navigate to="dashboard" />,
        },
        {
            path: '*',
            element: <NotFound />,
        },
    ]

    return all_routes
}
